// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"9b206860","566":"08a0e277"}[chunkId] + ".chunk.js";
};